import React from 'react';
import PropTypes from 'prop-types';

import './ProLabel.css';

const ProLabel = ({ small }) => (
  <div className={`pro-label__component${small ? ' small' : ''}`}>PRO</div>
);

ProLabel.propTypes = {
  small: PropTypes.bool,
};

ProLabel.defaultProps = {
  small: null,
};

export default ProLabel;
